import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CheckCircle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

const SuccessAlert = () => {
  const dispatch = useDispatch();
  const saveSuccess = useSelector((state) => state.geofences.saveSuccess);

  useEffect(() => {
    if (saveSuccess) {
      const timer = setTimeout(() => {
        dispatch({ type: "CLEAR_GEOFENCE_SUCCESS" });
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [saveSuccess, dispatch]);

  return saveSuccess ? (
    <div className="fixed top-4 left-1/2 transform -translate-x-1/2 z-50 transition-transform duration-500 ease-in-out">
      <Alert className="bg-green-600 text-white border-green-600 flex items-center p-3 rounded shadow-lg">
        <CheckCircle className="w-5 h-5 mr-2" />
        <AlertDescription className="text-white">
          {saveSuccess}
        </AlertDescription>
      </Alert>
    </div>
  ) : null;
};

export default SuccessAlert; 